import React from 'react';
import { Gift, User, Calendar, Clock, Sparkles, ArrowRight } from 'lucide-react';
import dayjs from 'dayjs';
import 'dayjs/locale/tr';

dayjs.locale('tr');

const LeaveEntitlementWidget = ({ stats, loading, onNavigate }) => {
    const hasPersonal = stats?.hasCurrentUserNewLeaveEntitlement;
    const personalDays = stats?.currentUserLeaveEntitlementDays;
    const personalDate = stats?.currentUserLeaveEntitlementDate;

    const hasUpcomingPersonal = stats?.hasCurrentUserUpcomingLeaveEntitlement;
    const upcomingPersonalDays = stats?.currentUserUpcomingLeaveEntitlementDays;
    const upcomingPersonalDate = stats?.currentUserUpcomingLeaveEntitlementDate;

    const teamCount = stats?.teamLeaveEntitlementCount || 0;
    const teamItems = stats?.teamLeaveEntitlementPreviewItems || [];

    const upcomingTeamCount = stats?.teamUpcomingLeaveEntitlementCount || 0;
    const upcomingTeamItems = stats?.teamUpcomingLeaveEntitlementPreviewItems || [];

    const totalPersonal = (hasPersonal ? 1 : 0) + (hasUpcomingPersonal ? 1 : 0);
    const totalTeam = teamCount + upcomingTeamCount;

    const goToLeaveBalances = () => {
        if (onNavigate) {
            onNavigate('leave_balances');
        } else {
            localStorage.setItem('currentPage', 'leave_balances');
            window.location.reload();
        }
    };

    if (loading) {
        return (
            <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-xl border border-gray-100 dark:border-gray-700 h-full flex items-center justify-center p-6">
                <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-blue-500"></div>
            </div>
        );
    }

    return (
        <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-xl border border-gray-100 dark:border-gray-700 overflow-hidden relative group transition-all hover:shadow-2xl h-full flex flex-col">
            <div className="absolute top-0 right-0 -mr-8 -mt-8 w-32 h-32 rounded-full bg-blue-500/10 blur-2xl pointer-events-none"></div>

            {/* Header */}
            <div className="p-3 pb-2 border-b border-gray-100 dark:border-gray-700 flex justify-between items-center bg-gray-50/50 dark:bg-gray-800/10 shrink-0">
                <div className="flex items-center space-x-2">
                    <div className="p-1.5 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-md shadow-inner text-white">
                        <Gift size={16} />
                    </div>
                    <h3 className="text-sm font-bold text-gray-800 dark:text-gray-100">İzin Hak Edişleri</h3>
                </div>
                <button
                    type="button"
                    onClick={goToLeaveBalances}
                    className="text-[11px] font-medium text-blue-600 dark:text-blue-400 hover:text-blue-800 dark:hover:text-blue-300 flex items-center gap-1 px-2 py-1 rounded hover:bg-blue-50 dark:hover:bg-blue-900/30 transition-colors"
                >
                    <span>Tümünü Gör</span>
                    <ArrowRight size={12} />
                </button>
            </div>

            {/* Body */}
            {totalPersonal === 0 && totalTeam === 0 ? (
                <div className="flex-1 flex flex-col items-center justify-center p-6 text-center">
                    <Gift size={40} className="mb-3 text-gray-300 dark:text-gray-600" strokeWidth={1.5} />
                    <p className="text-xs font-semibold text-gray-600 dark:text-gray-300 mb-1">
                        Yakın zamanda oluşan bir hak ediş yok.
                    </p>
                    <p className="text-[11px] text-gray-400 dark:text-gray-500 max-w-xs">
                        Senin veya ekibinin yeni izin hak edişleri (Geçmiş ve Gelecek 30 Gün) burada listelenir.
                    </p>
                </div>
            ) : (
                <div className="flex-1 p-3.5 flex flex-col gap-3 overflow-y-auto">
                    {/* 1) KİŞİSEL BÖLÜM */}
                    {totalPersonal > 0 && (
                        <div className="flex flex-col gap-2">
                            {hasPersonal && (
                                <div className="flex items-center justify-between p-3 bg-gray-50/80 dark:bg-gray-700/40 border border-gray-100 dark:border-gray-700 rounded-xl">
                                    <div className="flex items-center gap-3">
                                        <div className="w-9 h-9 rounded-lg bg-blue-100/80 dark:bg-blue-900/40 flex items-center justify-center text-blue-600 dark:text-blue-400 shrink-0">
                                            <User size={18} />
                                        </div>
                                        <div className="flex flex-col">
                                            <div className="flex items-center gap-1.5 mb-0.5">
                                                <span className="px-1.5 py-0.5 rounded text-[9px] font-bold uppercase tracking-wider bg-green-100 text-green-700 dark:bg-green-900/50 dark:text-green-400">
                                                    YENİ
                                                </span>
                                                <span className="text-[11px] text-gray-500 dark:text-gray-400 font-medium">
                                                    {stats?.currentUserLeaveEntitlementTypeName || 'Yıllık İzin'} Hakkın Tanımlandı
                                                </span>
                                            </div>
                                            <span className="text-gray-800 dark:text-gray-100 font-bold text-sm">
                                                <span className="text-base text-blue-600 dark:text-blue-400 mr-1">{personalDays}</span>
                                                Gün
                                            </span>
                                            <div className="flex items-center text-[10px] text-gray-400 dark:text-gray-500 mt-0.5">
                                                <Calendar size={11} className="mr-1" /> Hak Ediş: {personalDate ? dayjs(personalDate).format('DD MMM YYYY') : '-'}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {hasUpcomingPersonal && (
                                <div className="flex items-center justify-between p-3 bg-purple-50/60 dark:bg-purple-900/20 border border-purple-100 dark:border-purple-800/50 rounded-xl">
                                    <div className="flex items-center gap-3">
                                        <div className="w-9 h-9 rounded-lg bg-purple-100 dark:bg-purple-900/40 flex items-center justify-center text-purple-600 dark:text-purple-400 shrink-0">
                                            <Sparkles size={18} />
                                        </div>
                                        <div className="flex flex-col">
                                            <div className="flex items-center gap-1.5 mb-0.5">
                                                <span className="px-1.5 py-0.5 rounded text-[9px] font-bold uppercase tracking-wider bg-purple-100 text-purple-700 dark:bg-purple-900/50 dark:text-purple-400">
                                                    YAKLAŞAN
                                                </span>
                                                <span className="text-[11px] text-purple-700 dark:text-purple-300 font-medium">
                                                    {stats?.currentUserUpcomingLeaveEntitlementTypeName || 'Yıllık İzin'} Hak Edişiniz Yaklaşıyor
                                                </span>
                                            </div>
                                            <span className="text-purple-950 dark:text-purple-200 font-bold text-sm">
                                                Tahmini <span className="text-base mx-1">{upcomingPersonalDays}</span> Gün
                                            </span>
                                            <div className="flex items-center text-[10px] text-purple-600/80 dark:text-purple-400/80 mt-0.5">
                                                <Calendar size={11} className="mr-1" /> Hedef: {upcomingPersonalDate ? dayjs(upcomingPersonalDate).format('DD MMM YYYY') : '-'}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    )}

                    {/* 2) EKİP BÖLÜMÜ */}
                    {totalTeam > 0 && (
                        <div className="flex flex-col gap-2.5">
                            <div className="flex justify-between items-center px-1">
                                <span className="text-[11px] font-bold uppercase tracking-wider text-gray-500 dark:text-gray-400">
                                    Ekip Özeti
                                </span>
                                <span className="text-[10px] font-semibold bg-gray-100 dark:bg-gray-700 px-2 py-0.5 rounded-full text-gray-600 dark:text-gray-300">
                                    {totalTeam} İşlem
                                </span>
                            </div>

                            {/* GERÇEKLEŞEN EKİP İZİNLERİ */}
                            {teamCount > 0 && (
                                <div className="flex flex-col gap-1.5">
                                    <div className="text-[10px] font-semibold text-gray-400 dark:text-gray-500 uppercase tracking-widest pl-1">
                                        Son 30 Gün ({teamCount})
                                    </div>
                                    {teamItems.slice(0, 3).map((item, index) => (
                                        <div
                                            key={`past-${item.employeeId || 'emp'}-${index}`}
                                            className="flex items-center p-2 bg-gray-50 dark:bg-gray-700/40 border border-gray-100 dark:border-gray-700 rounded-lg"
                                        >
                                            <div className="w-8 h-8 rounded-full bg-blue-100 dark:bg-blue-900/40 text-blue-700 dark:text-blue-300 font-bold text-xs flex items-center justify-center mr-2.5 shrink-0">
                                                {item.fullName ? item.fullName.charAt(0).toUpperCase() : 'P'}
                                            </div>
                                            <div className="flex-1 min-w-0">
                                                <div className="text-xs font-semibold text-gray-800 dark:text-gray-100 truncate">
                                                    {item.fullName}
                                                </div>
                                                <div className="text-[10px] text-gray-500 dark:text-gray-400 flex items-center gap-1 truncate">
                                                    <span className="truncate">{item.departmentName}</span>
                                                    <span>•</span>
                                                    <span className="text-blue-600 dark:text-blue-400 font-medium truncate">
                                                        {item.leaveTypeName || 'Yıllık İzin'}
                                                    </span>
                                                    <span>•</span>
                                                    <span className="flex items-center gap-0.5 whitespace-nowrap">
                                                        <Clock size={10} /> {dayjs(item.entitlementDate).format('DD MMM')}
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="px-2 py-0.5 bg-blue-50 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400 rounded text-[11px] font-bold ml-2 border border-blue-100 dark:border-blue-800/50 whitespace-nowrap">
                                                +{item.shortLabel}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}

                            {/* YAKLAŞAN EKİP İZİNLERİ */}
                            {upcomingTeamCount > 0 && (
                                <div className="flex flex-col gap-1.5">
                                    <div className="text-[10px] font-semibold text-purple-500 dark:text-purple-400 uppercase tracking-widest pl-1">
                                        Gelecek 30 Gün ({upcomingTeamCount})
                                    </div>
                                    {upcomingTeamItems.slice(0, 3).map((item, index) => (
                                        <div
                                            key={`upcoming-${item.employeeId || 'emp'}-${index}`}
                                            className="flex items-center p-2 bg-purple-50/40 dark:bg-purple-900/15 border border-dashed border-purple-200 dark:border-purple-800/50 rounded-lg"
                                        >
                                            <div className="w-8 h-8 rounded-full bg-purple-100 dark:bg-purple-800/40 text-purple-700 dark:text-purple-300 font-bold text-xs flex items-center justify-center mr-2.5 shrink-0">
                                                {item.fullName ? item.fullName.charAt(0).toUpperCase() : 'P'}
                                            </div>
                                            <div className="flex-1 min-w-0">
                                                <div className="text-xs font-semibold text-gray-800 dark:text-gray-100 truncate">
                                                    {item.fullName}
                                                </div>
                                                <div className="text-[10px] text-purple-600/80 dark:text-purple-400/80 flex items-center gap-1 truncate">
                                                    <span className="truncate text-gray-500 dark:text-gray-400">{item.departmentName}</span>
                                                    <span>•</span>
                                                    <span className="font-medium truncate">{item.leaveTypeName || 'Yıllık İzin'}</span>
                                                    <span>•</span>
                                                    <span className="flex items-center gap-0.5 font-medium whitespace-nowrap">
                                                        <Calendar size={10} /> {dayjs(item.entitlementDate).format('DD MMM')}
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="px-2 py-0.5 text-purple-600 dark:text-purple-300 rounded text-[11px] font-bold ml-2 whitespace-nowrap">
                                                ~{item.entitlementDays} Gün
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default LeaveEntitlementWidget;
